<template>
  <div class="p-3 sm:p-8">
    <div
      v-if="loading"
      class="text-center py-10 flex items-center justify-center">
      <XSpinner class="text-4xl text-info-50" />
    </div>

    <div
      v-else
      class="sm:my-6 p-4 sm:p-6 rounded mx-auto max-w-2xl"
      :style="page.styles">
      <div v-html="page.content"/>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    config: {
      type: Object
    },
    loading: {
      type: Boolean
    }
  },

  computed: {
    page () {
      if (this.$route.name === 'registrationExpired') {
        return this.config.closed
      }

      if (this.$route.name === 'registrationSuccess') {
        return this.config.success
      }

      if (this.$route.name === 'registrationWaitingList') {
        return this.config.waitinglist
      }
    }
  }
}
</script>
